export enum OrgType {
  TREE = 'TREE',
  COUNTRY = 'COUNTRY',
  REGION = 'REGION',
  PRACTICE = 'PRACTICE',
}
